import React, { useEffect, useState } from 'react';
import { get, downloadFile } from '../utils/api';
import { Link } from 'react-router-dom';

const fmt = n => new Intl.NumberFormat('ru-RU', {minimumFractionDigits:0}).format(n||0) + ' ₽';
const fmtDate = d => { if (!d) return d; const [y, m, day] = d.split('-'); return `${day}-${m}-${y.slice(2)}`; };

export default function DashboardPage() {
  const [studios, setStudios] = useState([]);
  const [report, setReport] = useState(null);
  const [txs, setTxs] = useState([]);
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth()+1;

  useEffect(()=>{
    get('/studios').then(setStudios).catch(()=>{});
    get(`/reports/payments?year=${year}`).then(setReport).catch(()=>{});
    get('/transactions?').then(d=>setTxs(d.slice(0,8))).catch(()=>{});
  },[year]);

  const totalStudios = studios.length;
  const activeContracts = studios.filter(s=>s.active_contract_id).length;
  const monthlyIncome = studios.reduce((sum,s)=>sum+(s.current_rate||0),0);

  let unpaidThisMonth = 0;
  if (report) {
    report.contracts.filter(c => c.status === 'active').forEach(c => {
      const m = c.months[month];
      if (m && m.status === 'unpaid') unpaidThisMonth++;
    });
  }

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Дашборд <span>{new Date().toLocaleDateString('ru-RU',{month:'long',year:'numeric'})}</span></h1>
        <div style={{display:'flex',gap:10}}>
          <button className="btn btn-secondary btn-sm" onClick={()=>downloadFile('/export/excel','rental_export.xlsx')}>⬇ Excel</button>
          <button className="btn btn-secondary btn-sm" onClick={()=>downloadFile('/export/db','rental.db')}>⬇ База данных</button>
        </div>
      </div>

      <div className="stat-grid">
        <div className="stat-card"><div className="stat-label">Студий всего</div><div className="stat-value blue">{totalStudios}</div></div>
        <div className="stat-card"><div className="stat-label">Активных договоров</div><div className="stat-value green">{activeContracts}</div></div>
        <div className="stat-card"><div className="stat-label">Свободных</div><div className="stat-value">{totalStudios - activeContracts}</div></div>
        <div className="stat-card"><div className="stat-label">Ожидаемый доход/мес</div><div className="stat-value">{fmt(monthlyIncome)}</div></div>
        <div className="stat-card"><div className="stat-label">Не оплатили (тек. мес.)</div><div className="stat-value red">{unpaidThisMonth}</div></div>
      </div>

      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:20}}>
        <div className="card">
          <div className="section-title">Последние транзакции</div>
          {txs.length === 0 ? <div className="empty"><p>Транзакций нет</p></div> : (
            <div className="table-wrap">
              <table>
                <thead><tr><th>Дата</th><th>Описание</th><th>Сумма</th></tr></thead>
                <tbody>{txs.map(t=>(
                  <tr key={t.id}>
                    <td style={{color:'var(--text3)'}}>{fmtDate(t.date)}</td>
                    <td>{t.type==='income' ? (t.tenant_name || 'Доход') : (t.category_name || t.description || 'Расход')}</td>
                    <td style={{color:t.type==='income'?'var(--green)':'var(--red)',fontWeight:700}}>
                      {t.type==='income'?'+':'-'}{fmt(t.amount)}
                    </td>
                  </tr>
                ))}</tbody>
              </table>
            </div>
          )}
          <div style={{marginTop:12}}><Link to="/transactions" style={{color:'var(--accent)',fontSize:13}}>Все транзакции →</Link></div>
        </div>

        <div className="card">
          <div className="section-title">Статус оплат — {new Date().toLocaleDateString('ru-RU',{month:'long'})}</div>
          {!report ? <p style={{color:'var(--text3)'}}>Загрузка...</p> : (
            <div>
              {report.contracts.filter(c=>c.status==='active' && c.months[month]?.status!=='na').slice(0,10).map(c=>{
                const m = c.months[month];
                return (
                  <div key={c.id} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'8px 0',borderBottom:'1px solid var(--border)'}}>
                    <div>
                      <div style={{fontSize:14,fontWeight:600}}>{c.name}</div>
                      <div style={{fontSize:12,color:'var(--text3)'}}>Студия {c.studio_number}</div>
                    </div>
                    <span className={`badge badge-${m.status==='paid'?'green':m.status==='partial'?'yellow':'red'}`}>
                      {m.status==='paid'?'Оплачено':m.status==='partial'?'Частично':'Не оплачено'}
                    </span>
                  </div>
                );
              })}
              <div style={{marginTop:12}}><Link to="/reports/payments" style={{color:'var(--accent)',fontSize:13}}>Полный отчёт →</Link></div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
